import { render, staticRenderFns } from "./Betrieb.vue?vue&type=template&id=4acc2890&scoped=true"
import script from "./Betrieb.vue?vue&type=script&lang=js"
export * from "./Betrieb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc2890",
  null
  
)

export default component.exports